import React, { useState, useRef, useEffect } from "react";
import { CloseOutlined, CheckOutlined } from "@ant-design/icons";
import styles from "../styles/QurealRichEditor.module.css";

const LinkModal = ({ isOpen, onClose, onConfirm, initialUrl }) => {
    const [url, setUrl] = useState(initialUrl || "");
    const inputRef = useRef(null);

    useEffect(() => {
        if (isOpen && inputRef.current) {
            inputRef.current.focus();
            inputRef.current.select();
        }
    }, [isOpen]);

    if (!isOpen) return null;

    const handleSubmit = (e) => {
        e.preventDefault();
        onConfirm(url);
    };

    return (
        <div className={styles.linkModalOverlay}>
            <div className={styles.linkModal}>
                <div className={styles.linkModalHeader}>
                    <h3>Insert Link</h3>
                    <button className={styles.linkModalClose} onClick={onClose}>
                        <CloseOutlined />
                    </button>
                </div>
                <form onSubmit={handleSubmit}>
                    <div className={styles.linkModalBody}>
                        <input
                            ref={inputRef}
                            type="text"
                            value={url}
                            onChange={(e) => setUrl(e.target.value)}
                            placeholder="https://example.com"
                            className={styles.linkInput}
                        />
                    </div>
                    <div className={styles.linkModalFooter}>
                        <button
                            type="button"
                            className={`${styles.linkModalButton} ${styles.cancelButton}`}
                            onClick={onClose}
                        >
                            Cancel
                        </button>
                        <button
                            type="submit"
                            className={`${styles.linkModalButton} ${styles.confirmButton}`}
                        >
                            <CheckOutlined /> Apply
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default LinkModal;
